import { apiRequest, createAjaxError } from './apiRequest.js';
/**
 * Skapar ett ärende för i registred med angivet inrapporteringsformulär och för angiven patient.
 * @param {string} registerName
 * @param {string} formName
 * @param {number?} patientId
 *
 * @returns {Promise}
 */ export const createErrand = async (registerName, formName, patientId)=>{
    const registers = await apiRequest('/Registers', {
        params: {
            accessType: 'registration'
        }
    });
    const register = registers.find((x)=>x.name === registerName);
    if (!register) {
        return Promise.reject(createAjaxError('RegisterNotFound', `Registret ${registerName} kunde inte hittas.`));
    }
    const forms = await apiRequest(`/Registers/${register.id}/ReportingForms`);
    const form = forms.find((x)=>x.name === formName);
    if (!form) {
        return Promise.reject(createAjaxError('FormNotFound', `Inrapporteringsformuläret ${formName} kunde inte hittas.`));
    }
    return apiRequest('/Errands', {
        method: 'POST',
        json: {
            formId: form.id,
            patientId: patientId
        }
    });
};
export const createErrandByShortname = async (registerShortname, formShortname, patientId)=>{
    return apiRequest('/Errands', {
        method: 'POST',
        json: {
            registerShortName: registerShortname,
            formShortName: formShortname,
            patientId: patientId
        }
    });
};
export const executeAction = async (errand, transitionName, options)=>{
    const [transitions, data, df] = await Promise.all([
        apiRequest(`/Errands/${errand.id}/StateTransitions`),
        apiRequest(`/Errands/${errand.id}/Data`),
        apiRequest(`/Errands/${errand.id}/DesignedForm`)
    ]);
    const transition = transitions.find((x)=>x.event.name === transitionName);
    if (!transition) {
        return Promise.reject(createAjaxError('CreateErrandError', `Ärendeövergången ${transitionName} kunde inte hittas.`));
    }
    let onBeforeExecuteResult = Promise.resolve();
    const putErrand = {
        ...errand,
        data
    };
    const metadata = await apiRequest(`/DesignedForms/${df.id}/Metadata`);
    // Kolla om onBeforeExecute ska köras innan ärendets åtgärd körs.
    if (typeof options.onBeforeExecute === 'function') {
        onBeforeExecuteResult = Promise.resolve(options.onBeforeExecute(putErrand, df, metadata));
    }
    await onBeforeExecuteResult;
    // Executa actionen
    const executeResult = await apiRequest(`/Errands/${putErrand.id}/Event/${transition.event.id}/Execute`, {
        method: 'PUT',
        json: putErrand
    });
    return {
        designedForm: df,
        metadata: metadata,
        result: executeResult
    };
};
export const executeActionByShortname = async (errand, transitionShortname, options)=>{
    const [data, df] = await Promise.all([
        apiRequest(`/Errands/${errand.id}/Data`),
        apiRequest(`/Errands/${errand.id}/DesignedForm`)
    ]);
    let onBeforeExecuteResult = Promise.resolve();
    const putErrand = {
        ...errand,
        data
    };
    const metadata = await apiRequest(`/DesignedForms/${df.id}/Metadata`);
    // Kolla om onBeforeExecute ska köras innan ärendets åtgärd körs.
    if (typeof options.onBeforeExecute === 'function') {
        onBeforeExecuteResult = Promise.resolve(options.onBeforeExecute(putErrand, df, metadata));
    }
    await onBeforeExecuteResult;
    // Executa actionen
    const executeResult = await apiRequest(`/Errands/${putErrand.id}/Event/ShortName/${transitionShortname}/Execute`, {
        method: 'PUT',
        json: putErrand
    });
    return {
        designedForm: df,
        metadata: metadata,
        result: executeResult
    };
};
export const createErrandAndExecuteAction = async (registerName, formName, patientId, transitionName, options)=>{
    const errand = await createErrand(registerName, formName, patientId);
    return await executeAction(errand, transitionName, options);
};
export const createErrandAndExecuteActionByShortname = async (registerShortname, formShortname, patientId, transitionShortname, options)=>{
    const errand = await createErrandByShortname(registerShortname, formShortname, patientId);
    return await executeActionByShortname(errand, transitionShortname, options);
};
